import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-timeout-dialog',
    templateUrl: './timeout-dialog.component.html',
    styleUrls: ['./timeout-dialog.component.scss'],
    standalone: true,
    imports: [FlexModule, MatDialogModule, MatButtonModule]
})
export class TimeoutModalComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  timeoutMessage: string = "Timeout Started";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialogRef: MatDialogRef<TimeoutModalComponent>) {
  }

  ngOnInit(): void {
    let idle = this.data.idle;
    idle.onTimeoutWarning.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((countdown) => this.timeoutMessage = `You will time out in ${countdown} seconds!`);
  }

  close() {
    this.dialogRef.close();
  }
}

